import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';
import * as R from 'ramda';
import {
  resource,
} from 'common/store/selectors';

export const getScope = ({ widgets: { supplyData } }) => supplyData;

const chooseSafeNumber = (l, r) => (Number(r) || l);
const defaultSupplyWidgetData = {
  categoryOne: {
    powerOn: 0,
    powerOff: 0,
    unknown: 0,
  },
  categoryTwo: {
    powerOn: 0,
    powerOff: 0,
    unknown: 0,
  },
  categoryThree: {
    powerOn: 0,
    powerOff: 0,
    unknown: 0,
  }
};

export const {
  isLoading,
  getResourceContext,
  getResourceMaybe,
} = resource.factory(getScope);

export const getError = createSelector(
  getScope,
  ({ error }) => error,
);

export const getSupplyWidgetMaybe = createSelector(
  getResourceMaybe,
  resourceMaybe => S.map(
    R.mergeDeepWith(chooseSafeNumber, defaultSupplyWidgetData),
    S.chain(S.toMaybe, resourceMaybe),
  ),
);
